import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

const LEGACY_ADJUDICATION_STATUS_OPTIONS = [
  {
    id: "NONE",
    name: "None",
  },
  {
    id: "PROSPECT",
    name: "Prospect",
  },
  {
    id: "OFFER_PENDING",
    name: "Offer Pending",
  },
  {
    id: "PRE_ADVERSE_ACTION",
    name: "Pre Adverse Action",
  },
  {
    id: "POST_ADVERSE_ACTION",
    name: "Post Adverse Action",
  },
  {
    id: "OFFER_ACCEPTED",
    name: "Offer Accepted",
  },
  {
    id: "ARCHIVED",
    name: "Archived",
  },
];

export function LegacyAdjudicationStatusFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.adjudication_status?.split(",") || []}
      onSelectionChange={(keys) =>
        setParam("adjudication_status", Array.from(keys))
      }
      label={t("Adj. Status")}
      items={LEGACY_ADJUDICATION_STATUS_OPTIONS}
      selectionMode="multiple"
      testID="legacy-adjudication-status-filter"
    />
  );
}
